import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { Link } from "react-router";
import { useApiCall } from "../../../../../custom-hooks/api-call";
import DataNotFound from "../../../../../ui/loader/data-not-found";
import InnerLoader from "../../../../../ui/loader/inner-loader";
import UserIcon from "../../../../../icons/user";
import { SearchIcon } from "lucide-react";

const SearchPopup = ({ isOpen, onClose }) => {
  const apiCall = useApiCall();
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef();
  const [filtered, setFiltered] = useState([]);
  const [loader, setLoader] = useState(false);
  const [defaultState, setDefaultState] = useState(false);
  const [count, setCount] = useState('0');

  const callToApi = async (searchKey) => {
    setLoader(true);
    setCount(null)
    try {
      const apiData = JSON.stringify({ search_text: searchKey });
      const reps = await apiCall({ method: 'post', url: 'generic-search', data: apiData });
      setFiltered(reps?.search_text_result?.slice(0, searchKey ? reps?.search_text_result?.length : 10) || []);
      setCount(reps?.search_count);
    } catch (error) {
      console.error("API Error:", error);
      setFiltered([]);
      setCount(null);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const trimmed = searchTerm.trim();
      if (trimmed.length < 3) {
        setDefaultState(false); // Show default
        setFiltered([]);
        setLoader(false);
        setCount(null);
      } else {
        setDefaultState(true); // Hide default
        callToApi(trimmed);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setSearchTerm('');
        setDefaultState(true);
        onClose();
      };
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);

  const clos = () => {
    setSearchTerm('');
    setDefaultState(true);
    onClose();
  }

  if (!isOpen) return null;

  return (
    <div className={Style.search_backdrop} onClick={() => clos()}>
      <div className={Style.search_container} onClick={(e) => e.stopPropagation()}>
        <div className={Style.searchInput}>
          <div className={Style.searchIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="7" strokeWidth="2" />
              <path d="M21 21l-4.3-4.3" strokeWidth="2" />
            </svg>
          </div>
          <input
            type="text"
            ref={searchInputRef}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search people by name, email, phone?"
            className={Style.search_input}
          />

          <div className={Style.search_closed} onClick={() => {
            setSearchTerm('');
            // setDefaultState(true);
            onClose();
          }}>esc</div>
        </div>

        <div className={Style.search_body}>
          {
            (!defaultState) ? (
              <div className={Style.defaulState}>
                <div className={Style.defaulState_grid}>
                  <div className={Style.defaulState_item}>
                    <div className={Style.defaulState_card}>
                      <div className={Style.icon}>
                        <UserIcon />
                      </div>
                      Employee
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className={Style.userList}>
                <div className={Style.search_list}>
                  {!loader ? (
                    (filtered?.length > 0) ? (
                      filtered.map((item, idx) => (
                        <div key={idx} className={Style.search_item}>
                          <div className={Style.img}>
                            {
                              (item?.user_profile_picture) ? (
                                <img src={item.user_profile_picture} width={30} height={30} alt="Profile" />
                              ) : (
                                <span>
                                  {item?.user_name
                                    ?.split(' ')
                                    .map(w => w[0])
                                    .slice(0, 2)
                                    .join('')
                                    .toUpperCase()}
                                </span>

                              )
                            }
                          </div>
                          <div className={Style.cont}>
                            <h6>
                              {item.user_name}
                              <div className={`${(item?.emp_status == 'Active') ? Style.active : Style.inActive} ${Style.status}`}>
                                <b></b>
                              </div>
                            </h6>
                            <h5>{item.user_designation}</h5>
                            <p><span>{item.user_department_name}</span></p>
                            <div className={Style.tags}>
                              {
                                (item?.tags).map((ele, idex) => {
                                  return (
                                    <div key={`${idx}-${idex}`} className={Style.tag}>{ele}</div>
                                  )
                                })
                              }
                              <a href={`mailto:${item?.user_email}`} className={Style.tagEmail}>{item?.user_email}</a>
                            </div>

                            <div className={Style.detailIcon}>
                              <a href={`mailto:${item?.user_email}`} className={Style.detailAction}>
                                <svg data-source-pos="389:22-389:69" data-source-name="IconMail" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="w-5 h-5 text-slate-500"><path data-source-pos="138:4-138:46" data-source-name="path" d="M4 6h16v12H4z" stroke-width="2"></path><path data-source-pos="139:4-139:48" data-source-name="path" d="M22 6l-10 7L2 6" stroke-width="2"></path></svg>
                              </a>

                              <Link target="_blank" to={`/organization/employee-directory/${item?.user_id}`} className={Style.detailAction}>
                                <svg data-source-pos="399:22-399:69" data-source-name="IconUser" viewBox="0 0 24 24" fill="none" stroke="currentColor" class="w-5 h-5 text-slate-500"><path data-source-pos="144:4-144:66" data-source-name="path" d="M12 12a5 5 0 100-10 5 5 0 000 10z" stroke-width="2"></path><path data-source-pos="145:4-145:53" data-source-name="path" d="M2 22a10 10 0 0120 0" stroke-width="2"></path></svg>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <DataNotFound title={"Result"} className={Style.noDataFound} />
                    )
                  ) : (
                    <InnerLoader />
                  )}
                </div>
              </div>
            )
          }
        </div>
        <div className={Style.search_footer}>
          {count ? (`Result: ${count}`) : null}
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;
